import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-fj',
  templateUrl: './fj.component.html',
  styleUrls: ['./fj.component.scss']
})


export class FjComponent implements OnInit {
  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['fj'];
  }

}
